import { AccountsPage } from '@/components/accounts/AccountsPage';
import { uiStateActions } from '@/state/ui-state';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/accounts/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AccountsPage
      onAddAccount={() => {
        uiStateActions.openAddAccount();
      }}
    />
  );
}
